import {useEffect, useReducer, useRef} from "react"
import {logger} from "./logger";

enum ActionType{
    START="Start",
    ERROR="Error",
    SUCCESS="Success"
}

type Action={
    type:ActionType,
    payload?:any
}

let initialState = {
    inProgress:false,
    success:null,
    error:null
};

function reducer(state:any,action:Action){
    switch (action.type) {
        case ActionType.START:
            return {...state,inProgress:true,error:null,success:null}
            
        case ActionType.SUCCESS:
            return {...state,inProgress:false,error:null,success:action.payload}
        case ActionType.ERROR:
            return {...state,inProgress:false,error:action.payload,success:null}
        default:
            break;
    }
    return state;
}


function invoke<T>(req:Promise<T>,dispatch:React.Dispatch<Action>,hasUnmounted:()=>boolean){
    
    let safeDispatch=(val:Action)=>{
        if (!hasUnmounted()){
            dispatch(val);
        }
    }
    safeDispatch({
        type:ActionType.START
    });
    req.then(response=>{
        safeDispatch({
            type:ActionType.SUCCESS,
            payload:response
        });
    }).catch(err=>{
        safeDispatch({
            type:ActionType.ERROR,
            payload:err
        })
    });
}

export const useAsync=()=>{
    const [state,dispatch] = useReducer(reducer,initialState)
    let hasUnmounted=useRef(false);
    const checkIfComponentDisposed=()=>hasUnmounted.current;
    useEffect(()=>{
        return ()=>{
            hasUnmounted.current=true;
        }
    },[]);
    return {
        inProgress:state.inProgress,
        success:state.success,
        error:state.error,
        queryDispatcher:<T>(req:Promise<T>)=>{
            invoke(req,dispatch,checkIfComponentDisposed);
        }
    };
}